import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export interface SidebarProps {
  isOpen: boolean;
  gradientStartColor?: string;
  gradientStartPercent?: number;
  gradientEndColor?: string;
  gradientEndPercent?: number;
  isTeiaHeader?: boolean;
  isSuperAdmin?: boolean;
}

export const width = '255px';
export const transition = '0.3s';

export const closedWidth = '100px';

export const arrowDistanceFromWrapper = 12;

export const MainHeader = styled.div`
  display: flex;
  width: 100%;
  height: ${({ theme }) => theme.header.size};
  padding: 16px 25px;
  align-items: center;
  justify-content: center;
  background: transparent;
  box-shadow: none;
  margin: 0;
  border: none;

  & > div {
    padding-left: 10px;
    height: 100%;
    display: flex;
    align-items: center;

    & > a {
      height: 100%;
      width: 100%;

      & > img {
        max-height: 100%;
        max-width: 100%;
      }
    }
  }
`;

export const ProfileEdit = styled.div``;

export const LogoImg = styled.img<{ isOpen?: boolean; isTeiaHeader?: boolean }>`
  width: ${(props) => {
    if (props.isOpen) {
      if (props.isTeiaHeader) {
        return '98.8235px';
      } else {
        return '125.152px';
      }
    } else {
      return props.isTeiaHeader ? '50px' : '42px';
    }
  }};
  height: ${(props) => {
    if (props.isOpen) {
      return '56px';
    } else {
      return props.isTeiaHeader ? '56px' : '42px';
    }
  }};
`;

export const UserPanel = styled.div`
  padding: 25px 10px;
  box-shadow: none;
  position: relative;
  background: transparent;

  ${ProfileEdit} {
    opacity: 0;
    transition: ${transition};

    a {
      position: absolute;
      bottom: 72px;
      right: 91px;
      padding: 5px;
      background: #fff;
      border-radius: 30px;
      box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.13);
      display: flex;
      align-items: center;
    }
  }

  &:hover {
    ${ProfileEdit} {
      opacity: 1;
      transition: ${transition};
    }
  }

  h6 {
    color: ${({ theme }) => theme.colors.white};
    text-transform: uppercase;
    font-size: 0.875rem;
    font-weight: 600;
    letter-spacing: 1.5px;
    margin-bottom: 3px;
  }

  p {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 0.625rem;
    margin-bottom: 0;
    color: ${({ theme }) => theme.colors.white};
    opacity: 0.85;
  }

  img {
    width: 60px;
    height: 60px;
    /* object-fit: none; */
    /* object-position: center; */
    box-shadow: 0 0 15px rgba(68, 102, 242, 0.3);
  }
`;

export const UserEditIcon = styled(FontAwesomeIcon)`
  width: 24px;
  height: 24px;
`;

export const MenuItemIcon = styled(FontAwesomeIcon)<{ $collapsed?: boolean }>`
  width: 24px;
  height: 24px;
  margin-right: ${(props) => (props.$collapsed ? '0' : '14px')};
  stroke-width: 3px;
  vertical-align: sub;
  flex-shrink: 0;
`;

export const StyledMenuItem = styled.div<{ isTeiaHeader?: boolean; $collapsed?: boolean }>`
  padding: 8px;
  padding-left: ${(props) => (props.$collapsed ? '0' : '15px')};
  padding-right: ${(props) => (props.$collapsed ? '0' : undefined)};
  background: transparent;
  width: 100%;
  margin-top: 0;
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.$collapsed ? 'center' : 'flex-start')};
  box-sizing: border-box;
  
  &:hover {
    &:not(.disabled) {
      opacity: 0.9;
      background: ${(props) => props.isTeiaHeader ? '#F7941E' : '#5F2AB2'};
    }
  }

  &.active {
    opacity: 1;
    background: ${(props) => props.isTeiaHeader ? '#F7941E' : '#5F2AB2'};
  }

  &:hover {
    color: ${({ theme }) => theme.colors.white};
  }
  
  &:focus {
    color: ${(props) => props.isTeiaHeader ? '#F7941E' : '#5F2AB2'};
    background: ${(props) => props.isTeiaHeader ? '#F7941E' : '#5F2AB2'};
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  transition: ${transition};
`;

export const MenuItemHeader = styled(Link)<{ $collapsed?: boolean }>`
  display: flex;
  align-items: center;
  position: relative;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 2.5;
  letter-spacing: 0.5px;
  opacity: 1;
  width: ${(props) => (props.$collapsed ? 'auto' : '100%')};
  justify-content: ${(props) => (props.$collapsed ? 'center' : 'flex-start')};

  &:hover {
    color: ${({ theme }) => theme.colors.white};
  }

  &.active {
    color: ${({ theme }) => theme.colors.white};
  }

  color: ${({ theme }) => theme.colors.white};
`;

export const Menu = styled.ul`
  list-style: none;
  list-style-type: none;
  margin: 0;
  padding-left: 0;
  padding-right: 0;
  overflow-x: hidden;
  background: transparent;
  a {
    text-decoration: none;
  }
`;

export const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 72%;
  overflow-y: auto;
  margin-top: 0;
  background: transparent;
`;
export const SidebarLogo = styled.div`
  display: flex;
  width: calc(100% - 20px);
  justify-content: flex-end;
  position: absolute;
  right: 10px;
  cursor: pointer;
  bottom: 10px;
`;

export const StyledNav = styled.nav`
  margin-top: 30px;
  text-align: center;
`;

export const StyledToggleSidebar = styled.span<SidebarProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: calc(${({ theme }) => theme.header.size} + 10px);
  left: ${(props) => (props.isOpen ? 'calc(255px - 12px)' : 'calc(100px - 12px)')};
  width: 30px;
  height: 30px;
  transition: ${transition};
  border-radius: 50%;
  background-color: ${(props) => props.isTeiaHeader ? '#4CB2AC' : ({ theme }) => theme.sidebar.background};
  box-shadow: 0px 0px 5px 2px ${(props) => props.isTeiaHeader ? '#4CB2AC' : props.theme.sidebar.item};
  cursor: pointer;
  z-index: 100;

  &:hover {
    background-color: ${(props) => props.isTeiaHeader ? '#00599C' : '#5F2AB2'};
    box-shadow: 0px 0px 2px 2px ${(props) => props.isTeiaHeader ? '#00599C' : props.theme.sidebar.activeItem};
  }
`;
export const StyledToggleArrow = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.white};
`;

export const SidebarWrapper = styled.aside<SidebarProps>`
  width: ${width};
  height: 100vh;
  top: 0px;
  position: fixed;
  border-right: none;
  z-index: 49;

  background: ${(props) =>
    props.isSuperAdmin
      ? `${props.isTeiaHeader ? '#2677b6ff' : '#5F2AB2'} !important`
      : `linear-gradient(180deg, ${props.gradientStartColor ?? 'var(--Colour-usage-Background-Gradiente-Gradiente-2, #2E3139)'} ${props.gradientStartPercent ?? 0}%, ${props.gradientEndColor ?? 'var(--Colour-usage-Background-Gradiente-Gradiente, #5F2AB2)'} ${props.gradientEndPercent ?? 100}%)`
  };
  transition: ${transition};
  backdrop-filter: blur(5px);
  box-shadow: ${(props) =>
    props.isOpen ? '-3px 0px 15px 5px var(--secondary-g)' : '-3px 0px 15px 5px var(--secondary-g)'};

  @media screen and (max-width: 576px) {
    display: none;
  }

  &.content-hidden {
    & ${Sidebar} {
      & ${UserPanel} {
        div {
          position: relative;
          img {
            box-shadow: none;
          }
          &:before {
            position: absolute;
            content: '';
            width: 63px;
            height: 63px;
            background-color: ${({ theme }) => theme.body.background};
            top: -1px;
            left: 0;
            margin: 0 auto;
            right: 0;
            border-radius: 100%;
            animation: shine-lines 2s infinite ease-out;
            background-size: cover;
            background-color: ${(props) => props.isSuperAdmin ? (props.isTeiaHeader ? '#4CB2AC' : '#5F2AB2') : 'transparent'};
            background-image: ${(props) => props.isSuperAdmin ? 'none' : 'linear-gradient(90deg, #3d4d63 0px, rgb(71, 86, 107) 40px, #3d4d63 80px)'};
          }
          ${ProfileEdit} {
            opacity: 0;
          }
        }

        h6 {
          position: relative;
          &:before {
            position: absolute;
            width: 50%;
            content: '';
            height: 100%;
            background-color: ${({ theme }) => theme.body.background};
            top: 0;
            left: 0;
            right: 0;
            margin: 0 auto;
            border-radius: 20px;
            animation: shine-lines 2s infinite ease-out;
            background-size: cover;
            background-color: ${(props) => props.isSuperAdmin ? (props.isTeiaHeader ? '#4CB2AC' : '#5F2AB2') : 'transparent'};
            background-image: ${(props) => props.isSuperAdmin ? 'none' : 'linear-gradient(90deg, #3d4d63 0px, rgb(71, 86, 107) 40px, #3d4d63 80px)'};
          }
        }
        p {
          opacity: 0;
        }
      }
    }

    ${Sidebar} {
      ${Menu} {
        ${MenuItemHeader} {
          padding-left: 0;
          opacity: 0.7;
        }

        li {
          a {
            color: ${({ theme }) => theme.body.background};

            ${MenuItemIcon} {
              opacity: 0;
            }

            span {
              position: relative;
              span {
                &:before {
                  display: none;
                }
              }
              &:before {
                width: 110%;
                height: 100%;
                background-color: ${({ theme }) => theme.body.background};
                position: absolute;
                content: '';
                top: 0;
                left: -5%;
                border-radius: 20px;
                animation: shine-lines 2s infinite ease-out;
                background-size: cover;
                background-color: ${(props) => props.isSuperAdmin ? (props.isTeiaHeader ? '#4CB2AC' : '#5F2AB2') : 'transparent'};
                background-image: ${(props) => props.isSuperAdmin ? 'none' : 'linear-gradient(90deg, #3d4d63 0px, rgb(71, 86, 107) 40px, #3d4d63 80px)'};
              }
              + span {
                &:before {
                  display: none;
                }
              }
            }
          }
          &.active {
            a {
              &.active {
                span {
                  span {
                    &:before {
                      display: none;
                    }
                  }
                  &:before {
                    animation: shine-lines 2s infinite ease-out;
                    background-size: cover;
                    background-color: ${(props) => props.isSuperAdmin ? (props.isTeiaHeader ? '#4CB2AC' : '#5F2AB2') : 'transparent'};
                    background-image: ${(props) => props.isSuperAdmin ? 'none' : 'linear-gradient(90deg, #4b5a6f 0px, rgb(98, 115, 138) 40px, #4b5a6f 80px)'};
                  }
                  + span {
                    &:before {
                      display: none;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  @keyframes shine-lines {
    0% {
      background-position: -100px;
    }
    40%,
    100% {
      background-position: 0px;
    }
  }

  ~ .page-body {
    margin-left: ${width};
    transition: ${transition};
  }

  &.closed {
    display: block;
    width: ${(props) => (props.isOpen ? width : closedWidth)};

    ${MainHeader} {
      display: flex;
    }

    ${Sidebar} {
      ${Menu} {
        width: 100%;

        > li {
          display: flex;
          justify-content: center;
          width: 100%;
        }

        ${StyledMenuItem} {
          padding: 8px;
          padding-left: 0;
          padding-right: 0;
          text-align: center;
          justify-content: center;
          
          ${MenuItemHeader} {
            justify-content: center;
            padding: 0;
            
            span {
              display: none;
            }
            
            ${MenuItemIcon} {
              margin-right: 0;
              margin-left: 0;
            }
          }
        }
      }

      ${StyledNav} {
        width: 100%;
      }
    }

    ~ .page-body {
      margin-left: 0;
      transition: ${transition};
    }
    ~ div footer {
      margin-left: 0;
      padding-right: 15px;
    }
    ~ .footer-fix {
      width: calc(100% - 0px);
    }
  }
`;
